<script setup>
import CompanyForm from '@/components/registry/CompanyForm.vue'
</script>
<template>
  <company-form />
</template>
